import { Button } from "@repo/shad/ui/button"
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@repo/shad/ui/card"
import { Wallpaper } from "@repo/ui/components/wallpaper"
import { RefreshCw, WifiOff } from "lucide-react"

function ErrorContent({ onRetry }: { onRetry: () => void }) {
  return (
    <Card className="w-full max-w-sm border-white/10 bg-white/5 backdrop-blur-sm shadow-2xl shadow-moon rounded-t-xl overflow-hidden">
      <CardHeader className="pb-4">
        <div className="mx-auto mb-3 flex size-12 items-center justify-center rounded-full border border-white/10 bg-white/5">
          <WifiOff className="size-5 text-white/60" />
        </div>
        <CardTitle className="text-center text-lg font-semibold tracking-tight text-white">
          Unable to connect
        </CardTitle>
        <CardDescription className="text-center text-sm text-white/50">
          Our servers are temporarily unreachable. This usually resolves on its own in a few
          moments.
        </CardDescription>
      </CardHeader>
      <CardContent className="pb-4">
        <div className="rounded-lg border border-white/5 bg-white/[0.03] px-4 py-3">
          <p className="text-center text-xs text-white/40">
            Check your internet connection or try again shortly.
          </p>
        </div>
      </CardContent>
      <CardFooter>
        <Button
          onClick={onRetry}
          variant="outline"
          className="w-full border-white/15 bg-white/5 text-white hover:bg-white/10 hover:text-white"
        >
          <RefreshCw className="size-3.5" />
          Try again
        </Button>
      </CardFooter>
    </Card>
  )
}

/** Inline card for use inside AuthLayout on login/auth pages */
export function ConnectionErrorCard() {
  return <ErrorContent onRetry={() => window.location.reload()} />
}

/** Full-screen variant with dark blue wallpaper backdrop */
export function ConnectionErrorFullScreen() {
  return (
    <div className="dark">
      <Wallpaper color="blue" className="flex min-h-svh items-center justify-center px-4">
        <ErrorContent onRetry={() => window.location.reload()} />
      </Wallpaper>
    </div>
  )
}
